
/**
 * Открыть ссылку на новой вкладке
 * @param {url} url 
 */
export const openNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Хранит аккаунт пользователя
 */
export let account = null;

export function setAccount(acc) {
    account = acc;
}

/**
 * ChatGPT or StackOverFlow.com
 * @param {*} min 
 * @param {*} max 
 * @returns 
 */
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}